import Big from 'big.js';

export type Crypto = {
  address: string;
  created_at: string;
  is_used: boolean;
  tag: string | null;
};

export type CryptoResponse = {
  data: Crypto;
};

export type Challenge<T> = {
  id: string;
  purpose: string;
  payload: T;
};

export type CryptoWithdrawalInitResponse = {
  data: {
    withdrawal: CryptoWithdrawalResponse;
  };
};

export type CryptoWithdrawalResponse = {
  id: string | null;
  intent_id: string | null;
};

type DepositWithdrawState = {
  id: null | string;
  intentId: null | string;
};

export type withdrawCryptoState = DepositWithdrawState;
export type depositCryptoState = DepositWithdrawState;

export type CryptoWithdrawalTANResponse = CryptoWithdrawalPayload & {
  uuid: string;
};

export type CryptoWithdrawalPayloadResponse = {
  amount: string;
  asset_id: string;
  destination_tag: string;
  target_address: string;
  uuid: string;
};

export type CryptoWithdrawalPayloadBody = {
  amount: string;
  assetId: string | null;
  destinationTag: string;
  targetAddress: string;
  uuid: string;
};

export type CryptoWithdrawalPayload = {
  amount: string | Big;
  asset_id: string;
  destination_tag?: string;
  target_address: string;
};

export type CryptoWithdrawal = {
  amount: string;
  uuid: string;
  assetId: string;
  createdAt: string;
  finalizedAt: string | null;
  sourceAddress: string;
  sourceTag: string | null;
  targetAddress: string;
  destinationTag: string | null;
  transactionState: TransactionState;
  transactionType: TransactionType;
  transactionHash: string | null;
};

export type CryptoWithdrawals = CryptoWithdrawal[];

export type CryptoWithdrawalsPayload = {
  assetId: string;
  sortOrder?: string;
};

export type CryptoWithdrawalsResponse = {
  data: {
    amount: string;
    uuid: string;
    asset_id: string;
    created_at: string;
    finalized_at: string | null;
    source_address: string;
    source_tag: string | null;
    target_address: string;
    destination_tag: string | null;
    transaction_state: TransactionState;
    transaction_type: TransactionType;
    transaction_hash: string | null;
  }[];
};

export type Transaction = CryptoWithdrawal;

export type TransactionsResponse = CryptoWithdrawalsResponse;

export type TransactionsPayload = {
  page: number;
  sortOrder?: string;
};

export type CryptoDepositsPayload = {
  assetId?: string;
  sortOrder?: string;
  requiresTravelRuleOnly?: boolean;
};

export type CryptoDepositTravelRule = {
  amount: string;
  uuid: string;
  assetId: string;
  createdAt: string;
  depositIntentId: string;
  finalizedAt: string | null;
  sourceAddress: string;
  sourceTag: string | null;
  targetAddress: string;
  destinationTag: string | null;
  transactionState: TransactionState;
  transactionType: TransactionType;
  transactionhHash: string | null;
  withdrawalIntentId: string | null;
};

export type CryptoDepositTravelRuleResponse = {
  data: CryptoDepositTravelRule[];
};

export type TransactionState =
  | 'accepted'
  | 'completed'
  | 'created'
  | 'failed'
  | 'pending'
  | 'processing'
  | 'rejected'
  | 'sent'
  | 'user_timeout'
  | 'requirestravelruleinformation';

export type TransactionType = 'deposit' | 'withdrawal';

export enum TravelRuleType {
  Deposit = 'deposit',
  Withdrawal = 'withdrawal'
}
